import React from 'react';
import styled from 'styled-components';

const BotonFCM = () => {
  const handleClick = () => {
    window.location.href = 'http://10.90.1.7:8501';
  };

  return (
    <StyledWrapper>
      <button className="continue-application" onClick={handleClick}>
        <div className="left-badge">
          <span className="badge-text">FCM</span>
        </div>
        FCM 
      </button>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  .continue-application {
    --color: #fff;
    --background: #404660;
    --background-hover: #3a4059;
    --background-left: #2b3044;
    border: none;
    outline: none;
    cursor: pointer;
    position: relative;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 500;
    line-height: 19px;
    -webkit-appearance: none;
    -webkit-tap-highlight-color: transparent;
    padding: 17px 29px 17px 69px;
    transition: background 0.3s;
    color: var(--color);
    background: var(--bg, var(--background));
  }

  /* Contenedor izquierdo (texto FCM) */
  .continue-application .left-badge {
    top: 0;
    left: 0;
    bottom: 0;
    width: 53px;
    position: absolute;
    overflow: hidden;
    border-radius: 5px 0 0 5px;
    background: var(--background-left);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .continue-application .badge-text {
    font-weight: 700;
    letter-spacing: 0.5px;
    font-size: 12px;
    color: var(--color);
    user-select: none;
  }

  /* Detalles decorativos */
  .continue-application:before,
  .continue-application:after {
    content: "";
    position: absolute;
    width: 10px;
    height: 2px;
    border-radius: 1px;
    background: var(--color);
    transform-origin: 9px 1px;
    transform: translateX(var(--cx, 0)) scale(0.5) rotate(var(--r, -45deg));
    top: 26px;
    right: 16px;
    transition: transform 0.3s;
  }

  .continue-application:after {
    --r: 45deg;
  }

  .continue-application:hover {
    --cx: 2px;
    --bg: var(--background-hover);
  }
`;

export default BotonFCM;
